export default __webpack_public_path__ + "static/media/valentinesBannerWeb.8bc826e1.png";